export class AppConstants {
  // App Constants
  public static USERID = 'USER_ID';
  public static CCE_NAME = 'CCE_NAME';
  public static USER_FIRST_NAME = 'USER_FIRST_NAME';
  public static USER_LAST_NAME = 'USER_LAST_NAME';
  public static USER_TYPE = 'USER_TYPE';
  public static USER_ROLE = 'USER_ROLE';
  public static USER_SUB_TYPE = 'USER_SUB_TYPE';
  public static TOKEN = 'token';
  public static CLIENT_CORRELATION_ID = 'CLIENT_CORRELATION_ID';
  public static PARTICIPATION_ID = 'PARTICIPATION_ID';
  public static GLOBAL_HEADER = 'GLOBAL_HEADER';
  public static GLOBAL_FOOTER = 'GLOBAL_FOOTER';
  public static UNIVERSITY_NAME = 'UNIVERSITY_NAME';
  public static PARTICIPATION_LABEL = 'PARTICIPATION_LABEL';
  public static DOB: any;
  public static CASE_ID: any;
  public static MEMBER_DETAILS = 'MEMBER_DETAILS';
  public static EXTERNAL = 'EXTERNAL';
  public static USER_COUNTY = 'USER_COUNTY';
  public static SEARCH_TYPE = 'SEARCH_TYPE';
  // Status
  public static INVALID_STATUS = 'INVALID';
  public static FAILURE_STATUS = 'FAILURE';
  public static LOCKED_STATUS = 'LOCKED';
  public static SUCCESS_STATUS = 'SUCCESS';
  public static ERROR_STATUS = 'ERROR';
  public static INPUT_STATUS = 'REG_ERR_101';
  public static ROSTER_NOT_FOUND_STATUS = 'REG_ERR_102';
  public static REGISTRATION_ERROR_STATUS = 'REG_ERR_103';
  public static USER_EXISTS_STATUS = 'REG_ERR_104';
  public static SYSTEM_STATUS = 'REG_ERR_105';
  public static ENROLL_STATUS = 'REG_ERR_106';
  public static WRONG_FILE_FORMAT = 'UPLOAD_ERR_101';
  public static SIZE_ERROR = 'UPLOAD_ERR_102';

  // Data Service
  public static LOGIN_FAILED = 'LOGIN_FAILED';
  public static REGISTRATION_FAILED = 'REGISTRATION_FAILED';
  public static HIDE_MENU = 'HIDE_MENU';
  public static DASHBOARD_FAILED = 'DASHBOARD_FAILED';
  public static SUCCESS = 'SUCCESS';

  // My Account - My Details
  public static MY_ACCOUNT = 'MY_ACCOUNT';
  public static UPDATE_MYDETAILS_SUCCESS = 'UPDATE_MYDETAILS_SUCCESS';

  // My Account - Login Info
  public static VIRTUAL_MODE = 'VIRTUAL_MODE';
  public static PHONE_NUM = 'PHONE_NUM';
  public static EMAIL_ADD = 'EMAIL_ADD';
  public static MASKED_PHONE_NUM = 'MASKED_PHONE_NUM';
  public static MASKED_EMAIL_ADD = 'MASKED_EMAIL_ADD';
  public static FLOW = 'FLOW';
  public static OTP_VERIFIED = 'OTP_VERIFIED';
  public static PING_DEVICE_ID = 'PING_DEVICE_ID';
  public static PING_RISK_ID = 'PING_RISK_ID';
  public static PING_USER_ID = 'PING_USER_ID';
  public static ENCRYPTED_USER_ID = 'ENCRYPTED_USER_ID';
  public static USER_STATE = 'USER_STATE';
  public static SELECTED_COMPANY = 'SELECTED_COMPANY';
  public static APPLICATION_PDF = 'application/pdf';
  public static PREFERENCES = 'PREFERENCES';
  public static PREFERENCES_BKP = 'PREFERENCES_BKP';
  public static INTERNAL = 'INTERNAL';
  public static NPI_ID = 'NPI_ID';
  public static USER_ADMIN = 'user_admin';
  public static ACTIONS = 'ACTIONS';
  public static ALERTS = 'ALERTS';
  public static RRT_QUEUE_ID = '22284';
  public static VITE_NC_QUEUE_ID_MAP_CONFIG={"1":"23757","2":"23758","3":"23759","4":"23760","5":"23761","6":"23762","7":"23763"}
  public static SYSTEM_ERR_NC = 'Unfortunately, our system is currently experiencing issues. Please try again at a later time. If this problem continues, email <a href="mailto:DL-NCCarepointsConnect@healthybluenc.com"><strong><u>DL-NCCarepointsConnect@healthybluenc.com</u></strong></a> for assistance.';
}

export class ToolsAndResourcesConstants {
  public static get SORT_ATOZ(): string {
    return 'sortatoz';
  }
  public static get SORT_ZTOA(): string {
    return 'sortztoa';
  }

  public static get LANG_ALL(): string {
    return 'All';
  }
  ƒ;
  public static get LANG_SPANISH(): string {
    return 'Spanish';
  }

  public static get YES(): string {
    return 'Yes';
  }
  public static get NO(): string {
    return 'No';
  }

  public static get Y(): string {
    return 'Y';
  }
  public static get N(): string {
    return 'N';
  }

  public static get INITIAL_LIMIT(): number {
    return 20;
  }

  public static get CCP_DEFAULT_ACTIVE_TAB_KEY(): string {
    return 'PL';
  }
  public static get CCP_DEFAULT_ACTIVE_TAB_TITLE(): string {
    return 'Plans';
  }
  public static get CCP_DEFAULT_ACTIVE_TAB(): number {
    return 0;
  }

  public static get SUCCESS(): string {
    return 'Success';
  }
  public static get FAILURE(): string {
    return 'Failure';
  }
}
